/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "Zb3Wzs2FcFE",
    title: "Basic Pet Care: Dogs",
    description:
      "Dogs are amazing friends but they require constant care, commitment and resources. Learn how you can provide a comfortable and caring home for your pet dog in this video!",
    creator: "NParksSG",
    categoryName: "Pet Care",
    views: 2530,
    dateAdded: "September 16, 2021",
  },
  {
    _id: "Yzv0gXqoCkc",
    title: "Pet Care Basics",
    description:
      "Just like kids need their parents, pets need people to take care of their basic needs.  See what it takes to keep your pets happy, healthy and feeling loved!",
    creator: "MiamiDadeTV",
    categoryName: "Pet Care",
    views: 186733,
    dateAdded: "May 22, 2013",
  },
  {
    _id: "tNu4-G0SmRU",
    title: "Basic Pet Care: Cats",
    description:
      "Cats are fascinating animals, but they require constant care, commitment and resources. Learn how you can provide a comfortable and caring home for your pet cat in this video!",
    creator: "NParksSG",
    categoryName: "Pet Care",
    views: 4447,
    dateAdded: "December 16, 2020",
  },
  {
    _id: "Ydtg90LiSTY",
    title: "K-State Vet Med Virtual Tour - Student Spaces",
    description:
      "Welcome to the Kansas State University College of Veterinary Medicine! Let's take a tour of our spaces!",
    creator: "KSUCVM",
    categoryName: "Pet Care",
    views: 2842,
    dateAdded: "December 16, 2020",
  },
  {
    _id: "nKYmpzmiwzI",
    title: "Directional Terms in Veterinary Medicine",
    description:
      "Megan Brashear, CVT, VTS(ECC), summarizes the most comment directional terminology for veterinary communication.",
    creator: "atDove",
    categoryName: "Pet Care",
    views: 57572,
    dateAdded: "December 27, 2017",
  },
  {
    _id: "wt_K1beUZEI",
    title:
      "How to Place an Intravenous (IV) Catheter | Canine IV Catheter Placement",
    description:
      "IV access is important for many procedures and the cephalic catheter is the most common IV catheter placed in dogs and cats. This video will walk you through how to place a cephalic #intravenous #catheter in a dog.",
    creator: "atDove",
    categoryName: "Pet Care",
    views: 1653948,
    dateAdded: "July 23, 2012",
  },
  {
    _id: "ip6tRvn8iXU",
    title:
      "Vet Team Work Hard To Save Dog Bitten By Rattlesnake | Dr. Jeff: Rocky Mountain Vet",
    description:
      "IV access is important for many procedures and the cephalic catheter is the most common IV catheter placed in dogs and cats. This video will walk you through how to place a cephalic #intravenous #catheter in a dog.",
    creator: "Animal Planet",
    categoryName: "Pet Care",
    views: 301236,
    dateAdded: "January 26, 2020",
  },
  {
    _id: "i1tLmklz5BE",
    title:
      "Dog Needs Leg Amputated After Being Shot | Dr. Jeff: Rocky Mountain Vet",
    description:
      "Nalla was shot while protecting her owner from an armed robber, and the bullet has broken her leg and caused severe bruising. Dr Nichols has to amputate the leg, and finds the bullet which did the damage.",
    creator: "Animal Planet",
    categoryName: "Pet Care",
    views: 135114,
    dateAdded: "January 26, 2020",
  },
  {
    _id: "XncpYxECDB8",
    title:
      "Dr Petra Cares For Dog Who Was Neglected After Leg Surgery | Dr. Jeff: Rocky Mountain Vet",
    description:
      "Juicy Fruit was a patient at Planned Pethood who needed surgery for a broken leg. 2 months after her surgery she's brought back to the clinic with an infected wound, as her owners didn't bring her back for any check-ups.",
    creator: "Animal Planet",
    categoryName: "Pet Care",
    views: 182931,
    dateAdded: "February 02, 2020",
  },
  {
    _id: "I5FZN8u_khM",
    title: "Deaf Dog Has BB Pellet in Her Ear | Dr. Jeff Rocky Mountain Vet",
    description:
      "Pinky is deaf and is taken in from foster care for a check up of a limping leg. While taking X-rays, the vets discover a BB pellet by her ear.",
    creator: "Animal Planet",
    categoryName: "Pet Care",
    views: 155455,
    dateAdded: "February 02, 2020",
  },
  {
    _id: "MCrXDH516P0",
    title: "Hybrid Wolf Gets Tooth Ache Relief | Dr. Jeff: Rocky Mountain Vet",
    description:
      "Dr. Jeff visits Mission Wolf with a five-person crew to figure out why one of the hybrid wolves has stopped eating.",
    creator: "Animal Planet",
    categoryName: "Pet Care",
    views: 163502,
    dateAdded: "February 02, 2020",
  },
  {
    _id: "BYqmP_T7Wak",
    title: "Dr. Jeff Treats a Curious Wolfpack",
    description:
      "Dr. Jeff and his Planned Pethood Plus team are always ready for any animal emergency! Watch this bonus scene and check out the techniques Dr. Jeff must use to examine the maladies of these active, wild wolves!",
    creator: "Animal Planet",
    categoryName: "Pet Care",
    views: 1440041,
    dateAdded: "February 02, 2020",
  },
  {
    _id: "NqMkkyj9_kc",
    title: "How Do You Put a Cat's Face Back Together?",
    description:
      "When Chubbs is brought in to Planned Pethood with a broken jaw and eye socket, it's up to rookie vet Dr. Amy to put him back together again. But is she up for the challenge?",
    creator: "Animal Planet",
    categoryName: "Pet Care",
    views: 243949,
    dateAdded: "February 02, 2020",
  },
  {
    _id: "q-TgwGk1Btg",
    title: "Dog grooming for beginners 1 of 3",
    description:
      "this is a how to video on how to groom a dog. if you are a beginner then this video is for you.",
    creator: "General Pet Grooming",
    categoryName: "Pet Grooming",
    views: 655150,
    dateAdded: "July 21, 2018",
  },
  {
    _id: "e5gS4tdmqtY",
    title: "Dog grooming for beginners 2 of 3",
    description:
      "this is a how to video on how to groom a dog. if you are a beginner then this video is for you.",
    creator: "General Pet Grooming",
    categoryName: "Pet Grooming",
    views: 128644,
    dateAdded: "July 21, 2018",
  },
  {
    _id: "Dn7yiOcCiLQ",
    title: "Dog grooming for beginners 3 of 3",
    description:
      "this is a how to video on how to groom a dog. if you are a beginner then this video is for you.",
    creator: "General Pet Grooming",
    categoryName: "Pet Grooming",
    views: 74443,
    dateAdded: "July 21, 2018",
  },
  {
    _id: "FL9KzvIGW5Q",
    title: "Full coated Pomeranian haircut",
    description:
      "In this video, I am working with happy the Pom. I am giving him a slight trim all over. He was an amazing little guy to work with. I actually filmed this over a month ago but I am just now finishing some time to post it. Enjoy😘❤️",
    creator: "General Pet Grooming",
    categoryName: "Pet Grooming",
    views: 356296,
    dateAdded: "July 21, 2018",
  },
  {
    _id: "HT90hHcKw-c",
    title: "How to groom a Persian cat 2 of 2",
    description:
      "One of the best Persian cats we have here. I absolutely love working on her",
    creator: "General Pet Grooming",
    categoryName: "Pet Grooming",
    views: 253,
    dateAdded: "July 21, 2018",
  },
  {
    _id: "w224_LRnzBQ",
    title: "Persian cats❤️",
    description: "sweet persian cat getting his first hair cut",
    creator: "General Pet Grooming",
    categoryName: "Pet Grooming",
    views: 391,
    dateAdded: "July 21, 2018",
  },
  {
    _id: "6gLtQAM7_0Q",
    title: "Mr. kitty's first groom",
    description:
      "Mr. kitty's first groom sweet persian cat getting his first hair cut",
    creator: "General Pet Grooming",
    categoryName: "Pet Grooming",
    views: 226,
    dateAdded: "July 21, 2018",
  },
  {
    _id: "kcTL4vvtiow",
    title: "Pomeranian Fox-like cut",
    description: "Pomeranian Fox-like cut",
    creator: "General Pet Grooming",
    categoryName: "Pet Grooming",
    views: 25771,
    dateAdded: "November 28, 2018",
  },
  {
    _id: "6oTGVy_Pi_g",
    title: "PetGroooming - Ooops! Fix me please! Full Grooming Shih Tzu",
    description:
      "body and legs - 7 FC blade paws - 30 blade top of the head - snap on comb 13 mm body - 7 FC blade ( I used Aesculap)",
    creator: "PetGroooming",
    categoryName: "Pet Grooming",
    views: 316051,
    dateAdded: "November 28, 2018",
  },
  {
    _id: "kTrEiHRlKkA",
    title: "Head Grooming Senior Shih Tzu",
    description:
      "body and legs - 7 FC blade paws - 30 blade top of the head - snap on comb 13 mm body - 7 FC blade ( I used Aesculap)",
    creator: "PetGroooming",
    categoryName: "Pet Grooming",
    views: 7978,
    dateAdded: "November 28, 2018",
  },
  {
    _id: "ClgqtUOQzBo",
    title: "Cute Maltese Transformation - Grooming Maltese",
    description: "body - 4 FC blade",
    creator: "PetGroooming",
    categoryName: "Pet Grooming",
    views: 91825,
    dateAdded: "March 27, 2021",
  },
  {
    _id: "4ye_V6D77hA",
    title: "My Favorite Head Grooming - Yorkie",
    description: "body - 4 FC blade",
    creator: "PetGroooming",
    categoryName: "Pet Grooming",
    views: 19628,
    dateAdded: "August 15, 2021",
  },
  {
    _id: "ba8mk3oqr1g",
    title:
      "German Shepherd Carries Cat Toy Around The House For The New Kitten To Play With | The Dodo",
    description:
      "This German Shepherd always helped her Mom around the house and now she drags toys around so their new kitten will chase her 💜",
    creator: "The Dodo",
    categoryName: "Play with Pets",
    views: 1619606,
    dateAdded: "August 15, 2021",
  },
  {
    _id: "YqcQlg3MIHM",
    title:
      "Dog Who Had No Idea How To Play Invents A Game With A Cat | The Dodo Foster Diaries",
    description:
      "Dog who'd never been outside had no idea how to play — watch the first time she plays with a cat!",
    creator: "The Dodo",
    categoryName: "Play with Pets",
    views: 686501,
    dateAdded: "July 02, 2021",
  },
  {
    _id: "fkO14GdltIo",
    title:
      "Dog And Wild Dolphin Play Whenever They See Each Other | The Dodo Odd Couples",
    description:
      "Every time this dog, Zyzz, sees his favorite wild dolphin, Jojo, he jumps off the boat to play with him 💙",
    creator: "The Dodo",
    categoryName: "Play with Pets",
    views: 1024906,
    dateAdded: "July 02, 2021",
  },
  {
    _id: "f7PogRusFhg",
    title: "Cats and Kids Playing, Cuddling and Growing Up Together | The Dodo",
    description:
      "Cats and Kids Playing, Cuddling and Growing Up Together | When kids grow up with a cat, they get the best snuggle buddy — and a loyal friend for life.",
    creator: "The Dodo",
    categoryName: "Play with Pets",
    views: 161741,
    dateAdded: "July 02, 2021",
  },
  {
    _id: "Mcz33CC-oKE",
    title:
      "Cats and Kids Playing, Cuddling and Growing Up Together | The DodPuppy Teaches A Scared Work Horse How To Play | The Dodo Faith = Restored",
    description:
      "Rescued workhorse didn't trust anyone until a puppy decided to teach her how to play 💚",
    creator: "The Dodo",
    categoryName: "Play with Pets",
    views: 1458975,
    dateAdded: "July 02, 2021",
  },
  {
    _id: "hExhaWCnBxQ",
    title:
      "Dog's Best Friend Caught On Camera Sneaking Over To Play | The Dodo",
    description:
      "Great Dane Couldn't Make Other Dogs Friends — Until His New Neighbor Moved In",
    creator: "The Dodo",
    categoryName: "Play with Pets",
    views: 1008494,
    dateAdded: "July 02, 2021",
  },
  {
    _id: "1oDGa2yPb2g",
    title: "DOG TRAINING FUNDAMENTALS: LESSON 1",
    description:
      "Great Dane Couldn't Make Other Dogs Friends — Until His New Neighbor Moved In",
    creator: "Dogumentary TV",
    categoryName: "Pet Training",
    views: 2284898,
    dateAdded: "May 18, 2019",
  },
  {
    _id: "MW8X0IMVjzQ",
    title: "DOG TRAINING FUNDAMENTALS: LESSON 2 RECALL",
    description:
      "Please support the Channel by checking out my affiliate links!!!",
    creator: "Dogumentary TV",
    categoryName: "Pet Training",
    views: 658010,
    dateAdded: "May 18, 2019",
  },
  {
    _id: "psemvgmsI3Y",
    title: "DOG TRAINING FUNDAMENTALS: LESSON 3 LURING",
    description:
      "Please support the Channel by checking out my affiliate links!!!",
    creator: "Dogumentary TV",
    categoryName: "Pet Training",
    views: 379238,
    dateAdded: "June 21, 2019",
  },
  {
    _id: "Zt31jNGAKz4",
    title: "DOG TRAINING FUNDAMENTALS: LESSON 4: GOING TO PLACE",
    description:
      "Please support the Channel by checking out my affiliate links!!!",
    creator: "Dogumentary TV",
    categoryName: "Pet Training",
    views: 217942,
    dateAdded: "June 21, 2019",
  },
  {
    _id: "zEusaPfbn9s",
    title: "DOG TRAINING FUNDAMENTALS: LESSON 5: HEELING POSITION",
    description:
      "Please support the Channel by checking out my affiliate links!!!",
    creator: "Dogumentary TV",
    categoryName: "Pet Training",
    views: 154278,
    dateAdded: "June 21, 2019",
  },
  {
    _id: "WvNpP_Np5TA",
    title: "GERMAN SHEPHERD DOG: HUNTER TO HERDER",
    description:
      "Please support the Channel by checking out my affiliate links!!!",
    creator: "Dogumentary TV",
    categoryName: "Pet Training",
    views: 28263,
    dateAdded: "June 21, 2019",
  },
  {
    _id: "qOoCIlYxLb4",
    title:
      "Labrador Puppy Learning and Performing Training Commands | Dog Showing All Training Skills",
    description:
      "Dog Showing All Training Skills - Our 12 weeks old Labrador Puppy Buddy learning and performing basic training commands like Sit, Stay, Shake, High 5, Lie Down, Crawl, Give Paw, Spin, Bark and other training. Dog showing training skills tricks. The training video is in Hindi with English Subtitles. Retriever training video. Labrador puppy doing tricks. ",
    creator: "Furry Friend",
    categoryName: "Pet Training",
    views: 8472442,
    dateAdded: "June 21, 2019",
  },
  {
    _id: "Kj7ihQJuc3E",
    title:
      "How to Pee and Potty Train your Puppy at Home | How I Did it (You will Thank Me for This)",
    description:
      "Puppy Potty Training - In this video i share my experiences on how i pee (susu) and potty trained my Labrador puppy Buddy at home within a month",
    creator: "Furry Friend",
    categoryName: "Pet Training",
    views: 3239589,
    dateAdded: "June 21, 2019",
  },
  {
    _id: "ls-aKsBTp0w",
    title:
      "How to Reduce Puppy Biting/Nipping | My Experiences (Tips that ACTUALLY Work!!)",
    description:
      "How to stop a puppy from biting your hands and feet - Check out how i trained our Labrador Puppy to stop biting when i ask him to. There are 3 tips that i would like to share with you to help in reducing your puppy's biting problem. Check them out and make sure to practice this training every day.",
    creator: "Furry Friend",
    categoryName: "Pet Training",
    views: 946420,
    dateAdded: "July 05, 2020",
  },
  {
    _id: "nhRibVjN9YM",
    title:
      "How to Train a Puppy or Dog to Patiently Wait for Food and Not Bark (Easy Training Tips)",
    description:
      "Train your dog to wait for food - With this video i am starting the training videos on this channel. In this video, i am training Buddy, our Labrador Puppy, to patiently wait for food and stop barking when i serve the food.",
    creator: "Furry Friend",
    categoryName: "Pet Training",
    views: 1379327,
    dateAdded: "July 05, 2020",
  },
];
